export default class LoadMore {
    constructor( element ) {
        if ( null === element ) {
            return;
        }

        this.element = element;
        this.progress = false;
        this.finished = false;
        this.page = 1;
        this.action = this.element.getAttribute( 'data-action');
        this.type = this.element.getAttribute( 'data-load-more' );
        this.type = null === this.type ? 'infinite' : this.type;

        this.init();
    }

    init() {
        if ( this.type === 'infinite' ) {
            window.addEventListener('scroll', ( e ) => {
                if ( this.reachedBottom() ) {
                    this.load();
                }
            }, false);
        } else {
            let trigger = document.querySelector( '[data-load-trigger="' + this.action + '"]' );
            
            if ( null !== trigger ) {
                trigger.addEventListener( 'click', ( e ) => {
                    e.preventDefault();
                    this.load();

                    this.element.addEventListener( 'loaded', ( e ) => {
                        if ( this.finished === true ) {
                            trigger.remove();
                        }
                    } );
                } );
            }
        }
    }

    reachedBottom() {
        let bounding = this.element.getBoundingClientRect();
        
        if ( ( Math.abs(bounding.y) + window.innerHeight ) > bounding.height ) {
            return true;
        }

        return false;
    }

    load() {
        if ( this.progress !== true && this.finished !== true ) {
            this.progress = true;

            let data = '';

            this.page = this.page + 1;
            data += 'action=' + this.action;

            if ( this.element.getAttribute( 'data-search' ) ) {
                let search = this.element.getAttribute( 'data-search' );
                data += '&s=' + search;
            }

            if ( this.element.getAttribute( 'data-before' ) ) {
                let before = this.element.getAttribute( 'data-before' );
                data += '&before=' + before;
            }

            data += '&page=' + this.page;

            let request = new XMLHttpRequest();
            request.open( 'GET', themeVars.ajax_url + '?' + data, true );
            request.send( null );

            request.onreadystatechange = () => {
                if ( request.readyState === 4 && request.status === 200 ) {
                    let response = JSON.parse( request.responseText );

                    if ( response.data.finished === true ) {
                        this.finished = true;
                    }

                    this.progress = false;
                    this.element.innerHTML += response.data.html;
                    this.element.dispatchEvent( new Event( 'loaded' ) );
                }
            }
        }
    }
}
